import React, { useEffect, useRef, useState } from "react";

// Sprint UI-GLOBALE — scorrimento orizzontale delle liste con barra ancorata in basso,
// usabile a metà elenco. La barra nativa del contenitore è nascosta, quella ancorata la sostituisce.
export default function StickyHScroll({ children, testid = "sticky-hscroll" }) {
  const box = useRef(null);
  const bar = useRef(null);
  const [w, setW] = useState({ scroll: 0, client: 0 });
  useEffect(() => {
    const el = box.current;
    if (!el) return undefined;
    const misura = () => setW({ scroll: el.scrollWidth, client: el.clientWidth });
    misura();
    const ro = new ResizeObserver(misura);
    ro.observe(el);
    if (el.firstElementChild) ro.observe(el.firstElementChild);
    return () => ro.disconnect();
  }, []);
  const sync = (from, to) => { if (to.current && from.current && to.current.scrollLeft !== from.current.scrollLeft) to.current.scrollLeft = from.current.scrollLeft; };
  const serve = w.scroll > w.client + 1;
  return (
    <>
      <div ref={box} onScroll={() => sync(box, bar)} className="overflow-x-auto no-native-hscroll" data-testid={testid}>
        {children}
      </div>
      {serve && (
        <div className="sticky bottom-0 z-20 bg-white border-t border-slate-200 py-1 px-1" data-testid={`${testid}-bar`} aria-hidden="true">
          <div ref={bar} onScroll={() => sync(bar, box)} className="hscroll-bar overflow-x-auto overflow-y-hidden">
            <div style={{ width: w.scroll, height: 1 }} />
          </div>
        </div>
      )}
    </>
  );
}
